import { CountryEndPoints, pageNo } from "../../config";
import { getQueryStringFrmObject, postApi, getApi } from "../helpers/utility";

class CountryApi {
  create = async (countryPojo) => {
    console.log("countrypojo", countryPojo);
    if (countryPojo) {
      //   console.log("Country pojo", JSON.stringify(countryPojo));
      var result = await postApi(CountryEndPoints.add, countryPojo);
      return result;
    }
  };

  read = async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = CountryEndPoints.list + "?pageNo=" + page + "&per_page=" + pageNo;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint + "&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };

  findById = async (countryId) => {
    var result = await getApi(CountryEndPoints.findById, countryId);
    return result;
  };
}
export default new CountryApi();
